import { render, staticRenderFns } from "./Career.vue?vue&type=template&id=2c5b37fa&scoped=true"
import script from "./Career.vue?vue&type=script&lang=js"
export * from "./Career.vue?vue&type=script&lang=js"
import style0 from "./Career.vue?vue&type=style&index=0&id=2c5b37fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b37fa",
  null
  
)

export default component.exports